<div class="header">
  <div class="buttons-container">
    <button (click)="saveTimeline()" id="save-timeline">Save timeline</button>
  </div>
</div>
<div #visTimeline id="timeline"></div>
